/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MissionStepType {
    ACCOUNT = 'Account',
    TRANSACTION = 'Transaction',
    TRANSACTION_DETAIL = 'TransactionDetail',
}